import React, { FormEvent } from "react";
import { api, CompanyEmployeeInviteDto } from "shared/api";
import { useApiMethod, UseModalProps } from "shared/lib";
import { Entity, LoadingDots, Modal, Error } from "shared/ui";

export interface IEmployeeInviteDeleteModal extends UseModalProps {
  companySlug: string;
  data: CompanyEmployeeInviteDto;
}

export const EmployeeInviteDeleteModal = (props: IEmployeeInviteDeleteModal) => {
  const submit = useApiMethod(api.companyEmployeeInvite.companyEmployeeInviteDelete);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    await submit.call(props.companySlug, props.data.id);
    await props.onSuccess();
  };

  return (
    <Modal onClose={props.close} width={450}>
      <form onSubmit={onSubmit}>
        <Modal.Header>
          <Modal.Title>Удаление приглашения</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Entity>
            <Entity.Field flex title={props.data.email} />
            <Entity.Field flex description={props.data.companyEmployeeRole.name} right />
          </Entity>

          {submit.error && <Error style={{ marginTop: 24 }}>{submit.error.message}</Error>}
        </Modal.Body>

        <Modal.Actions>
          <Modal.Action htmlType="button" onClick={props.close}>
            Отмена
          </Modal.Action>

          <Modal.Action htmlType="submit" disabled={submit.loading}>
            {!submit.loading ? "Удалить" : <LoadingDots size={4}>Удаление</LoadingDots>}
          </Modal.Action>
        </Modal.Actions>
      </form>
    </Modal>
  );
};

EmployeeInviteDeleteModal.defaultProps = {};
